var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLighthouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "M120 60c0 33.137-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0s60 26.863 60 60Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20.5,
  height: 2.71,
  x: 77.167,
  y: 40.44,
  fill: "#FCE7B1",
  rx: 1.355,
  transform: "rotate(-6.364 77.167 40.44)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 20.5,
  height: 2.71,
  fill: "#FCE7B1",
  rx: 1.355,
  transform: "scale(-1 1) rotate(-6.364 341.857 403.419)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 4.501,
  height: 2.71,
  x: 99.667,
  y: 37.895,
  fill: "#FCE7B1",
  rx: 1.355,
  transform: "rotate(-6.364 99.667 37.895)"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 4.501,
  height: 2.71,
  fill: "#FCE7B1",
  rx: 1.355,
  transform: "scale(-1 1) rotate(-6.364 330.225 199.771)"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 14.909,
  height: 2.602,
  x: 77.441,
  y: 48.334,
  fill: "#FCE7B1",
  rx: 1.301,
  transform: "rotate(6.05 77.441 48.334)"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 14.909,
  height: 2.602,
  fill: "#FCE7B1",
  rx: 1.301,
  transform: "scale(-1 1) rotate(6.05 -477.9 -376.418)"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 8.724,
  height: 2.602,
  x: 95.107,
  y: 50.334,
  fill: "#FCE7B1",
  rx: 1.301,
  transform: "rotate(6.05 95.107 50.334)"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 8.724,
  height: 2.602,
  fill: "#FCE7B1",
  rx: 1.301,
  transform: "scale(-1 1) rotate(6.05 -487.99 -208.254)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C5CFD9",
  d: "M69.833 40.667a9.667 9.667 0 1 0-19.333 0h19.333ZM64 101.167c0-.525-.103-5.378-.304-5.864a3.997 3.997 0 0 0-5.227-2.165 3.998 3.998 0 0 0-2.165 2.165c-.2.486-.304 5.339-.304 5.864h8Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C5CFD9",
  d: "m50.667 54.084-4.083 47.083h13.833V54.084h-9.75Z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "lighthouse_svg__a",
  width: 120,
  height: 120,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "M119.945 59.972c0 33.03-26.776 59.806-59.806 59.806S.334 93.002.334 59.972 27.11.167 60.139.167c33.03 0 59.806 26.776 59.806 59.805Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.667,
  mask: "url(#lighthouse_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.656 40.62c0-5.204 4.222-9.427 9.428-9.427 5.205 0 9.427 4.223 9.427 9.428M60.084 28.5v2.694M47.963 40.621h24.242M50.656 40.621v8.08M60.084 40.621v8.08M69.51 40.621v8.08M72.205 48.701H47.963M47.963 54.089h24.242M50.657 54.089l-4.04 47.137M69.51 54.089l4.041 47.137M41.23 106.613v-5.387h37.709v5.387M50.656 109.306s2.694 2.693 9.428 2.693c6.733 0 9.427-2.693 9.427-2.693"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.51 109.306s2.69 2.693 8.081 2.693c5.39 0 8.08-2.693 8.08-2.693M85.672 109.306s2.69 2.693 8.08 2.693c5.39 0 8.081-2.693 8.081-2.693M34.495 109.306s2.69 2.693 8.08 2.693c5.391 0 8.081-2.693 8.081-2.693"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.334 109.306s2.69 2.693 8.08 2.693c5.391 0 8.081-2.693 8.081-2.693M56.044 101.225v-4.04a4.04 4.04 0 0 1 4.04-4.04 4.04 4.04 0 0 1 4.04 4.04v4.04M47.963 86.411h18.855M49.04 75.637h16.43M49.849 64.862h14.275M100.438 38.083l1.397-.155M77.592 40.62l17.521-1.945M95.022 50.638l6.811.757M77.592 48.701l12.12 1.347M19.731 38.083l-1.397-.155M42.576 40.62l-17.521-1.945M25.145 50.638l-6.811.757M42.576 48.701l-12.12 1.347"
}))));
export default SvgLighthouse;